export default "__VITE_ASSET__wI$5nN0f__"